module.exports = __webpack_public_path__ + "img/bell-icon.963190a6.svg";